<template>
  <div class="d-lg-none">
    <div
      class="mobile-menu-overlay"
      :class="[{ active: showSidebar }]"
      @click="hideSidebar"
    />
    <div class="mobile-menu" :class="[{ active: showSidebar }]">
      <div class="mobile-menu__header">
        <div class="mobile-menu__logo">
          <img src="/images/sm-logo-white.svg" alt="" />
        </div>
        <div class="mobile-menu__close-btn" @click="hideSidebar">
          <icon name="menu-new-icon" />
        </div>
      </div>
      <div class="mobile-menu__subheader">
        <ul class="extra-menu">
          <li class="extra-menu__item">
            <a href="" class="extra-menu__link">
              <div class="extra-menu__link-icon">
                <icon name="header__controls-link-1" />
              </div>
            </a>
          </li>
          <li class="extra-menu__item">
            <router-link
              to="/my-calendar"
              class="extra-menu__link"
              :class="{ active: $route.name === 'VueCal' }"
              @click.native="changePage('/my-calendar')"
            >
              <div class="extra-menu__link-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.4444 5H6.55556C5.69645 5 5 5.69645 5 6.55556V17.4444C5 18.3036 5.69645 19 6.55556 19H17.4444C18.3036 19 19 18.3036 19 17.4444V6.55556C19 5.69645 18.3036 5 17.4444 5Z"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15 3V6"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 3V6"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 10H19"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </router-link>
          </li>
          <li class="extra-menu__item disabled">
            <a href="" class="extra-menu__link">
              <div class="extra-menu__link-icon">
                <div class="extra-menu__link-amount">5</div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 12.6L10.5385 15L19 7"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19 12V17.4444C19 17.857 18.8361 18.2527 18.5444 18.5444C18.2527 18.8361 17.857 19 17.4444 19H6.55556C6.143 19 5.74733 18.8361 5.45561 18.5444C5.16389 18.2527 5 17.857 5 17.4444V6.55556C5 6.143 5.16389 5.74733 5.45561 5.45561C5.74733 5.16389 6.143 5 6.55556 5H15.1111"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </a>
          </li>
          <li class="extra-menu__item disabled">
            <a href="" class="extra-menu__link">
              <div class="extra-menu__link-icon">
                <div class="extra-menu__link-amount">2</div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 8V12.5L15 14"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </a>
          </li>
          <li class="extra-menu__item">
            <router-link
              to="/board-draw"
              class="extra-menu__link"
              :class="{ active: $route.name === 'BoardDraw' }"
              @click.native="changePage('/board-draw')"
            >
              <div class="extra-menu__link-icon">
                <icon name="header__controls-link-6" />
              </div>
            </router-link>
          </li>
          <li class="extra-menu__item" v-if="!isStudent">
            <router-link
              class="extra-menu__link"
              active-class="active"
              to="/chat"
              @click.native="changePage('/chat')"
            >
              <div class="extra-menu__link-icon">
                <svg data-v-66a8324e="" width="24" height="24">
                  <use
                    data-v-66a8324e=""
                    xlink:href="/images/sprite.svg#header__controls-link-10"
                  ></use>
                </svg>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="mobile-menu__body">
        <div class="mobile-menu__top">
          <NewMenu :user="user" @logout="logout" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import NewMenu from '@/Components/Layout/NewMenu';

export default {
  name: 'TheSidebarOld',
  components: { NewMenu },
  data() {
    return {
      // showSidebar: false,
      showBlock: true,
      active: undefined,
      menu: [
        {
          route_path: 'student-list',
          name: 'תלמידים',
          active: 'students',
          show: false,
          hasPermission: () =>
            this.$perm('student.list', this.selectedCampus.id) ||
            this.$perm('student.show', this.selectedCampus.id),
          subcategories: [
            {
              name: 'מועמדים לקליטה',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('menu.applicants', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת מועמדים',
                  url: '/new-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'תלמידים וחניכים',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('menu.students', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת תלמידים',
                  url: '/student-list',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('student.list', this.selectedCampus.id) ||
                    this.$perm('student.show', this.selectedCampus.id)
                },
                // {
                //     name: 'ציונים',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                // {
                //     name: 'צווי בית משפט',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                {
                  name: 'הערכות חניך',
                  url: '/assessment-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_student_assessment',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'חוות דעת',
                  url: '/feedback-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_feedbacks',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'וועדות ופיקוחים',
                  url: '/commission-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_commission',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'שיחות אישיות',
                  url: '/personal-conversation-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_personal_conversations',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'ליווי הורים',
                  url: '/parent-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('student.view_parents', this.selectedCampus.id)
                },
                // {
                //     name: 'טיפול רפואי',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                // {
                //     name: 'תהליכים טיפוליים',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                {
                  name: 'אישורי חניכים',
                  url: '/students-security',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('student.view_parents', this.selectedCampus.id)
                },
                {
                  name: 'אירועים חריגים',
                  url: '/incident-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_incidents',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'נוכחות חניכים',
                  url: '/reports',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('report.list', this.selectedCampus.id) ||
                    this.$perm('report.show', this.selectedCampus.id)
                }
                // {
                //     name: 'אישורי יציאה',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
              ]
            },
            {
              name: 'בוגרים',
              url: '',
              danger: 0,
              warning: 0,
              show: false,
              hasPermission: () =>
                this.$perm('menu.graduates', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת בוגרים',
                  url: '/graduated-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'עוזבי המסגרת',
              url: '',
              danger: 0,
              warning: 0,
              show: false,
              hasPermission: () =>
                this.$perm('menu.expelled_students', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת עוזבי המסגרת',
                  url: '/kicked-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'חניכים שנמחקו',
              url: '',
              danger: 0,
              warning: 0,
              show: false,
              hasPermission: () =>
                this.$perm('menu.removed_students', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת חניכים שנמחקו',
                  url: '/deleted-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: 'workers-list',
          name: 'עובדים',
          active: 'workers',
          show: false,
          hasPermission: () =>
            this.$perm('worker_list.show', this.selectedCampus.id),
          subcategories: [
            {
              name: 'רשימת עובדים',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'רשימת עובדים',
                  url: '/workers-list',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: '',
          name: 'פנימיה',
          active: 'boarding-school',
          show: false,
          subcategories: []
        },
        {
          route_path: '',
          name: 'מרכז מוזיקה',
          active: 'music-school',
          show: false,
          subcategories: []
        },
        {
          route_path: '',
          name: 'חוגים',
          active: 'sections',
          show: false,
          subcategories: []
        },
        {
          route_path: 'service-orders',
          name: 'אחזקה',
          active: 'maintenance',
          show: false,
          hasPermission: () =>
            this.$perm('service_orders.list', this.selectedCampus.id) ||
            this.$perm('service_orders.show', this.selectedCampus.id) ||
            this.$perm('service_orders.create', this.selectedCampus.id),
          subcategories: [
            {
              name: 'רשימת קריאות',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'רשימת קריאות',
                  url: '/service-orders',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: '/centers/:slug/day',
          name: 'מרכז למידה',
          active: 'study-center',
          show: false,
          hasPermission: () => true,
          subcategories: [
            {
              name: 'מרכז למידה',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'עריכת תבנית',
                  url: '/study-center/template',
                  danger: 0,
                  warning: 0
                },
                // {
                //   name: 'חודש',
                //   url: '/study-center/month',
                //   danger: 0,
                //   warning: 0
                // },
                // {
                //   name: 'שבוע',
                //   url: '/study-center/week',
                //   danger: 0,
                //   warning: 0
                // },
                {
                  name: 'יום',
                  url: '/centers/:slug/day',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'דו״ח מורים',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'דו״ח מורים',
                  url: '/study-center/reports',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'דו״חות',
                  url: '/study-center/reports/week',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },

        {
          route_path: '/security/entry  ',
          name: 'ביטחון',
          active: 'security',
          show: false,
          hasPermission: () =>
            this.$perm('security.can_view', this.selectedCampus.id),
          subcategories: []
        },
        {
          route_path: '',
          name: 'הסעות',
          active: 'transport',
          show: false,
          subcategories: []
        }
      ]
    };
  },
  computed: {
    isStudent() {
      return this.$store.getters['auth/user'].entity_id === 2;
    },
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({
      user: 'auth/user',
      settings: 'settings/getSettings'
    }),
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    part() {
      return this.menuPart ? this.menuPart : false;
    }
  },
  watch: {
    '$route.fullPath'() {
      this.findActiveMenu();
    }
  },
  mounted() {
    // this.findActiveMenu();
  },
  methods: {
    ...mapActions({
      setSidebarStatus: 'front/setSidebarStatus',
      signOut: 'auth/signOut'
    }),
    changePage(path) {
      this.$router.push({
        path,
        query: { 'open-menu': 0 }
      });
      this.setSidebarStatus(false);
      this.$emit('showMenu', false);
    },
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    async logout() {
      await this.signOut();
    },
    hideSidebar() {
      this.$router.push({
        path: this.$route.fullPath,
        query: { 'open-menu': 0 }
      });
      this.setSidebarStatus(false);
      this.$emit('showMenu', false);
    },
    getCategory() {
      const category = this.menu.filter(item => {
        return item.active === this.part;
      });
      // console.log(category);
      // console.log(category[0].subcategories);
      return category && category[0] ? category[0].subcategories : [];
    },
    openPage(path, hideSidebar) {
      if (window.innerWidth < 992) {
        this.hideSidebar();
      }
      this.$router.push({ path });
    },
    findActiveMenu() {
      // this.menu.forEach(menu => {
      //   menu.subcategories.forEach(subcategory => {
      //     if (_.isArray(subcategory.items)) {
      //       subcategory.items.forEach(item => {
      //         if (this.$route.path === item.url) {
      //           subcategory.show = true;
      //           menu.show = true;
      //           this.active = menu.active;
      //         }
      //       });
      //     }
      //   });
      // });
    }
  }
};
</script>

<style lang="scss">
.router-link-exact-active {
  text-decoration: none;

  &.mobile-menu__row {
    .btn--blue.disabled {
      background: linear-gradient(270deg, #409fff 32.55%, #3078bf 100%);
      color: #fff;
    }
  }

  .mobile-menu__back-btn.disabled svg {
    stroke: #fff !important;
  }
}
</style>
